import { render, staticRenderFns } from "./tan_needGz_portrait_botAdvise.vue?vue&type=template&id=1cf4e3d2&scoped=true"
import script from "./tan_needGz_portrait_botAdvise.vue?vue&type=script&lang=js"
export * from "./tan_needGz_portrait_botAdvise.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_portrait_botAdvise.vue?vue&type=style&index=0&id=1cf4e3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4e3d2",
  null
  
)

export default component.exports